import { createAsyncAction, } from 'typesafe-actions';

import * as types from './types';
import { repositories, } from 'api';

export const fetchInfo = createAsyncAction(
    types.FETCH_INFO_REQUEST,
    types.FETCH_INFO_SUCCEEDED,
    types.FETCH_INFO_FAILED,
)<string, repositories.InfoType, Error>();
